const TOKEN_STORAGE_KEY = 'advika_vendor_access_token';
export const VENDOR_SESSION_EVENT = 'advika-vendor-session';

let accessToken =
  typeof window !== 'undefined'
    ? window.localStorage.getItem(TOKEN_STORAGE_KEY)
    : null;

const emitSessionEvent = (reason) => {
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(VENDOR_SESSION_EVENT, { detail: { reason } }));
  }
};

export const setToken = (token) => {
  accessToken = token;
  if (typeof window !== 'undefined') {
    window.localStorage.setItem(TOKEN_STORAGE_KEY, token);
  }
  emitSessionEvent('updated');
};

export const getToken = () => accessToken;

export const clearToken = (reason = 'cleared') => {
  accessToken = null;
  if (typeof window !== 'undefined') {
    window.localStorage.removeItem(TOKEN_STORAGE_KEY);
  }
  emitSessionEvent(reason);
};

export const isTokenExpired = (token = accessToken) => {
  if (!token) return true;

  try {
    const payload = JSON.parse(atob(token.split('.')?.[1] || ''));
    if (!payload?.exp) return false;
    return payload.exp * 1000 <= Date.now();
  } catch {
    return true;
  }
};
